function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
// Imports
var ARRAY = 'array';
var BOOLEAN = 'boolean';
var FLOAT = 'float';
var INTEGER = 'integer';
var TEXTAREA = 'textarea';
var MAX_OPTIONS_FOR_TAB_FIELD = 6;
/**
 * Mapps filter settings to specific input field type.
 *
 * Not Required. If setting is not mapped here the default input fields are used.
 * See: defaultSettingsComponentsNames()
 */

var CUSTOMIZED_FILTERS_MAP = [{
  filterClass: 'SecureGate::Filters::MaxMindFilter',
  settingsMaps: [{
    settings: ['min_risk_score', 'max_risk_score', 'min_proxy_score', 'max_proxy_score'],
    fieldName: 'PercentField'
  }]
}];
/**
 * Simple wrapper object for a filter setting.
 * Provides methods to determinate what input field the setting requires.
 */

var RiskFilterSetting = /*#__PURE__*/function () {
  function RiskFilterSetting(setting, filterClass) {
    _classCallCheck(this, RiskFilterSetting);

    this["default"] = setting["default"];
    this.label = setting.label;
    this.name = setting.name;
    this.options = setting.options;
    this.tooltip = setting.tooltip;
    this.type = setting.type;
    this.value = setting.value;
    this.filterClass = filterClass;
  }

  _createClass(RiskFilterSetting, [{
    key: "fieldComponentName",
    get: function get() {
      if (this.componentNameForCustomizedSetting()) {
        return this.componentNameForCustomizedSetting();
      }

      if (this.componentNameForSettingWithOptions()) {
        return this.componentNameForSettingWithOptions();
      }

      return this.componentNameForSettingWithoutOptions();
    }
  }, {
    key: "componentNameForCustomizedSetting",
    value: function componentNameForCustomizedSetting() {
      var _this = this;

      var componentFieldName = '';
      CUSTOMIZED_FILTERS_MAP.forEach(function (_ref) {
        var customizedFilterClass = _ref.filterClass,
            settingsMaps = _ref.settingsMaps;

        if (customizedFilterClass === _this.filterClass) {
          settingsMaps.forEach(function (map) {
            componentFieldName = map.settings.includes(_this.name) ? map.fieldName : undefined;
          });
        }
      });
      return componentFieldName;
    }
  }, {
    key: "componentNameForSettingWithOptions",
    value: function componentNameForSettingWithOptions() {
      if (this.options) {
        if (this.type === ARRAY) {
          return 'SelectMultiField';
        }

        if (this.options.length <= MAX_OPTIONS_FOR_TAB_FIELD) {
          return 'TabField';
        }

        return 'SelectField';
      }
    }
  }, {
    key: "componentNameForSettingWithoutOptions",
    value: function componentNameForSettingWithoutOptions() {
      switch (this.type) {
        case BOOLEAN:
          return 'CheckboxField';

        case TEXTAREA:
          return 'TagsField';

        case INTEGER:
          return 'NumberField';

        case FLOAT:
          return 'NumberField';

        default:
          return 'TextField';
      }
    }
  }]);

  return RiskFilterSetting;
}();

export default RiskFilterSetting;